import { Button } from "primereact/button";
import { useContext, useEffect, useState } from "react";
import { LOADING_ON, LOADING_OFF } from "../../business/constants";
import { useIntegrations } from "../../hooks/integrations/useIntegrations";
import { StoreContext } from "../../business/Provider";
import { FullLoading } from "../FullLoading";

export const IntegrationComponent = ({
  children,
  title = "Importar información de la nómina",
  message = "Para comenzar a utilizar el control de asistencia de Colabora es necesario realizar una réplica inicial de información desde su sistema de nómina para obtener el detalle de  Colaboradores, Turnos, Tarjetas de vacaciones, Incapacidades, entre otros. Este proceso solo se realizará una vez y puede tardar varios minutos.",
  confirmButtonLabel = "Confirmar",
  requireVacationImport = true,
}) => {
  const [companyData, setCompanyData] = useState(null);

  const { postIntegrations } = useIntegrations();
  const { loadingState, getCompanySettings, dispatchLoading } =
    useContext(StoreContext);

  useEffect(() => {
    const { companies } = getCompanySettings;

    if (companies !== null) {
      setCompanyData(companies);
    }
  }, [getCompanySettings]);

  const postData = async () => {
    try {
      dispatchLoading({ type: LOADING_ON });
      await postIntegrations();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
    dispatchLoading({ type: LOADING_OFF });
  };

  const renderMessage = () => {
    return (
      <div className="flex bg-white w-full h-full justify-center content-center items-center relative overflow-x-hidden overflow-y-hidden">
        <FullLoading loadingState={loadingState} />
        <div className="flex w-full h-full md:w-1/2 md:h-1/2 lg:w-[45%] lg:h-[35%] xl:w-1/3 xl:h-1/3 2xl:w-1/3 2xl:h-1/3 flex-col border shadow-2xl rounded-md border-[#004B93]">
          <div className="flex w-full h-[15%] content-center items-center">
            <p className="ml-2 font-bold">{title}</p>
          </div>
          <div className="flex w-full h-[70%] p-1 justify-center items-center content-center">
            <p className="ml-2 font-semibold text-justify mr-2">{message}</p>
          </div>
          <div className="flex w-full h-[15%] justify-end">
            <Button
              label={confirmButtonLabel}
              className="flex !w-32 !h-4 !bg-blue-800 !text-white !mr-2"
              onClick={postData}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderEmptyWindow = () => {
    return (
      <div className="flex bg-white w-full h-full justify-center content-center items-center relative overflow-x-hidden overflow-y-hidden" />
    );
  };


  let attendanceImportDetail = null;

  if (companyData?.attendanceImportDetail) {
    try {
      attendanceImportDetail =
        typeof companyData.attendanceImportDetail === "string"
          ? JSON.parse(companyData.attendanceImportDetail)
          : companyData.attendanceImportDetail;
    } catch (error) {
      console.error("Error parsing attendanceImportDetail", error);
    }
  }

  const isCoreAttendanceImportComplete =
    attendanceImportDetail?.WorkShift === true &&
    attendanceImportDetail?.IncidentType === true &&
    attendanceImportDetail?.Periods === true &&
    attendanceImportDetail?.PeriodsType === true &&
    attendanceImportDetail?.Incident === true &&
    attendanceImportDetail?.Inhability === true &&
    attendanceImportDetail?.Status === true &&
    attendanceImportDetail?.Collaborators === true;

  const isFullAttendanceImportComplete =
    isCoreAttendanceImportComplete &&
    attendanceImportDetail?.Benefits === true &&
    attendanceImportDetail?.BenefitRelation === true;

  const isAttendanceImportComplete = requireVacationImport
    ? companyData?.attendanceComplete === 100 &&
      attendanceImportDetail?.Vacation === true &&
      isFullAttendanceImportComplete
    : isCoreAttendanceImportComplete;

  const validateMessage = isAttendanceImportComplete
    ? children
    : renderMessage();

  return companyData === null ? renderEmptyWindow() : validateMessage;
};
